'use strict'

angular.module('rmProgram')

    .config(['$stateProvider', function ($stateProvider) {

        let presenterCreateStateCreate = {
            url: '/new-presenter',
            views: {
                'presentersdetail@': {

                    templateUrl: '/partial/app.partials.presenter.detail',
                    controller: 'PresenterFormCtrl',
                    controllerAs: 'presenterCtrl'
                }
            },
            params: {
                fromOtherSource: true
            },
            onEnter: ['$state', 'bladesManager', function ($state, bladesManager) {
                var loadedViews = bladesManager.all()
                var found = loadedViews.some(function (el) {
                    return el.viewName === 'presentersdetail'
                })
                let size = $state.includes('broadcast') ? 'one-third' : 'half'
                if (!found) {
                    bladesManager.insertRight({ viewName: 'presentersdetail', size: size })
                }
            }],
            onExit: ['$state', '$stateParams', 'bladesManager', function ($state, $stateParams, bladesManager) {
                //ugly!
                if ($state.includes('programs.create')) {
                    bladesManager.removeRight('presentersdetail')
                } else if ($state.includes('programs.update')) {
                    bladesManager.removeRight('presentersdetail')
                }
            }]
        }
        let presenterCreateStateUpdate = angular.copy(presenterCreateStateCreate)

        $stateProvider
            .state('programs', {
                url: '/programs',
                views: {
                    programsoverview: {
                        templateUrl: '/partial/app.partials.program.overview',
                        controller: 'ProgramOverviewCtrl',
                        controllerAs: 'programCtrl'
                    },
                    programdetail: {
                        templateUrl: '/partial/app.panels.empty'
                    }
                },

                onEnter: ['bladesManager', function (bladesManager) {
                    bladesManager.clearAll()
                    bladesManager.insert({ viewName: 'programsoverview', size: 'half' })
                    bladesManager.insert({ viewName: 'programdetail', size: 'half' })
                }],

                resolve: {

                    itemFilters: ['$http', function ($http) {
                        return $http.get('/usersettings').then((req) => {
                            return req.data.item_filter
                        })
                    }],

                    filterMap: ['$http', function ($http) {
                        return $http.get('/userfilters/program').then((req) => {
                            return req.data
                        })
                    }]
                }
            })
            .state('programs.create', {
                url: '/create',
                views: {
                    'programdetail@': {
                        templateUrl: '/partial/app.partials.program.detail',
                        controller: 'ProgramFormCtrl',
                        controllerAs: 'programCtrl',
                    },
                },
            })
            .state('programs.update', {
                url: '/update/:programId',
                views: {
                    'programdetail@': {
                        templateUrl: '/partial/app.partials.program.detail',
                        controller: 'ProgramFormCtrl',
                        controllerAs: 'programCtrl',
                    },
                },
            })
            .state('programs.create.presenter', presenterCreateStateCreate)
            .state('programs.update.presenter', presenterCreateStateUpdate)
    }])

/*

app.config(function ($stateProvider) {

	$stateProvider
		.state('program', {
			url: '/program',
			templateUrl: '/partial/app.partials.program.overview',
			controller: 'ProgramOverviewCtrl',
			controllerAs: 'programCtrl'
		})
        .state('program.create', {
			url: '/create',
            views: {
                detail: {
                    templateUrl: '/partial/app.partials.program.detail',
                    controller: 'ProgramFormCtrl',
                    controllerAs: 'ctrl'
                }
            }
		})
        .state('program.update', {
            url: '/update/:id',
            views: {
                detail: {
                    templateUrl: '/partial/app.partials.program.detail',
                    controller: 'ProgramFormCtrl',
                    controllerAs: 'ctrl'
                }
            }
        });
});
*/
